const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M9.5 15.784c0 .191.279.288.443.154 1.48-1.208 3-2.393 4.419-3.648a.372.372 0 0 0 0-.58c-1.419-1.255-2.94-2.44-4.419-3.648-.164-.134-.443-.037-.443.154z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
